import React from "react";
import "./checkout.css";
import Loader from "../Loader";

const ProcessingOverlay = ({msg}) => {
  return (
    <div className="processing-overlay">
      <div className="processing-message">
        <Loader />
        Processing your order...
        <br />
        Please do not refresh the page or click the back button.
        <br />
        This may take a few moments. Your order will be placed shortly.
      </div>
    </div>
  );
};

export default ProcessingOverlay;
